import { ChevronDown } from "lucide-react";
import { useState } from "react";

// Shared settings pattern: collapsed on entry, full-width touch target.
export default function SettingsSection({ title, subtitle, children, id, defaultOpen = false, status }) {
  const [open, setOpen] = useState(defaultOpen);
  return <details id={id} open={open} onToggle={event => setOpen(event.currentTarget.open)} className="group mt-4 rounded-xl border border-border bg-card/60">
    <summary className="flex min-h-20 cursor-pointer list-none items-center justify-between gap-4 rounded-xl p-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary [&::-webkit-details-marker]:hidden">
      <span className="min-w-0"><span className="block font-semibold">{title}</span>{subtitle && <span className="mt-1 block text-xs text-muted-foreground">{subtitle}</span>}{status && <span className="mt-2 block">{status}</span>}</span>
      <ChevronDown aria-hidden="true" className="h-4 w-4 shrink-0 text-muted-foreground transition-transform group-open:rotate-180" />
    </summary>
    <div className="space-y-4 border-t border-border p-5">{children}</div>
  </details>;
}

